/**
 * Change LagerArchiv Filter
 */
window.changeLagerArchivFilter = function (area, subTab) {
    // per Ajax speichern
    let filterCheckboxes = [];
    $('div#filter-checkbox').find('input[type="checkbox"]').each(function () {
        filterCheckboxes.push({
            'key': $(this).attr('name'),
            'value': $(this).is(':checked')
        });
    });

    $.ajax({
        url: BASE_PATH + 'ajax/helper/lager/ajax.saveLagerArchivFilter',
        type: 'post',
        data: {
            data: filterCheckboxes,
            tabItem: area,
            subTab: subTab
        },
        success: function () {
            // Liste updaten
            if (typeof ListLagerArchiv !== 'undefined') {
                ListLagerArchiv.updater();
            }
        }
    });
};